import { UPLOADED_FILE_STATUS } from "common/constants";

export const importStatuses = [
  { value: UPLOADED_FILE_STATUS["s1"], name: "In Progress" },
  { value: UPLOADED_FILE_STATUS["s2"], name: "Promoted" },
  { value: UPLOADED_FILE_STATUS["s3"], name: "Erased" },
];
